/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A prompt-injection finding for the current skill version. Raw matched content is intentionally omitted.
 */
export type SkillPromptInjectionFinding = {
  /**
   * The classifier confidence from 0 to 1.
   */
  confidence: number;
  /**
   * Why the current skill version was flagged.
   */
  description: string;
  /**
   * The rule that produced the finding.
   */
  ruleId: string;
};

/** @internal */
export const SkillPromptInjectionFinding$inboundSchema: z.ZodMiniType<
  SkillPromptInjectionFinding,
  unknown
> = z.pipe(
  z.object({
    confidence: z.number(),
    description: z.string(),
    rule_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "rule_id": "ruleId",
    });
  }),
);

export function skillPromptInjectionFindingFromJSON(
  jsonString: string,
): SafeParseResult<SkillPromptInjectionFinding, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillPromptInjectionFinding$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillPromptInjectionFinding' from JSON`,
  );
}
